import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import Payers from './pages/Payers';
import Policies from './pages/Policies';
import { ThemeProvider } from './context/ThemeContext';
export function App() {
  return <ThemeProvider data-id="element-0">
      <Router data-id="element-1">
        <Layout data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Dashboard data-id="element-5" />} data-id="element-4" />
            <Route path="/payers" element={<Payers data-id="element-7" />} data-id="element-6" />
            <Route path="/policies" element={<Policies data-id="element-9" />} data-id="element-8" />
            <Route path="/history" element={<div className="p-6" data-id="element-11">History Page</div>} data-id="element-10" />
            <Route path="/testing" element={<div className="p-6" data-id="element-13">Testing Page</div>} data-id="element-12" />
            <Route path="/archives" element={<div className="p-6" data-id="element-15">Archives Page</div>} data-id="element-14" />
            <Route path="/monitoring" element={<div className="p-6" data-id="element-17">Monitoring Page</div>} data-id="element-16" />
            <Route path="/notifications" element={<div className="p-6" data-id="element-19">Notifications Page</div>} data-id="element-18" />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>;
}